import { RootState } from 'redux/reducers/rootReducer';
import { createSelector } from '@reduxjs/toolkit';
import { PayCodeModel } from 'api/adminApiClient';

const assignmentCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentCreatedAt;
const assignmentDraftCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentDraftCreatedAt;
const jobTitlesSelector = (state: RootState) => state.assignment.jobTitles;
const isJobTitlesLoadingSelector = (state: RootState) =>
  state.assignment.isJobTitlesLoading;
const workCodesSelector = (state: RootState) => state.assignment.workCodes;
const isWorkCodesLoadingSelector = (state: RootState) =>
  state.assignment.isWorkCodesLoading;
const payCodesDetailsInfoSelector = (state: RootState) =>
  state.assignment.payCodes;
const typesPayCodeSelector = (state: RootState) =>
  state.assignment.typesPayCode;
const isTypesPayCodeLoadingSelector = (state: RootState) =>
  state.assignment.isTypesPayCodeLoading;
const payRateTypesSelector = (state: RootState) =>
  state.assignment.payRateTypes;
const isPayCodeTypesLoadingSelector = (state: RootState) =>
  state.assignment.isPayCodeTypesLoading;
const assignmentDetailsSelector = (state: RootState) =>
  state.assignment.assignmentDetails;
const isTemplateAssignmentModalOpenSelector = (state: RootState) =>
  state.assignment.isTemplateAssignmentModalOpen;
const assignmentTemplateCreatedAtSelector = (state: RootState) =>
  state.assignment.assignmentTemplateCreatedAt;
const assignmentDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.assignment.assignmentDetailsUpdatedAtByAdmin;

const payCodesSelector = createSelector(
  payCodesDetailsInfoSelector,
  typesPayCodeSelector,
  (payCodesDetailsInfo, typesPayCode) =>
    typesPayCode?.map((typePayCode) => {
      const payCodesDetails = typePayCode?.payCodeId
        ?.map((codeId) => {
          const found = payCodesDetailsInfo.find((o) => o.id === codeId);
          return found ? found : null;
        })
        .filter((item) => item !== null) as PayCodeModel[] | undefined;
      return {
        assignmentType: typePayCode.assignmentType,
        payCodeDetails: payCodesDetails,
      };
    }),
);

export {
  jobTitlesSelector,
  assignmentDetailsSelector,
  assignmentCreatedAtSelector,
  assignmentDraftCreatedAtSelector,
  isJobTitlesLoadingSelector,
  isTemplateAssignmentModalOpenSelector,
  assignmentTemplateCreatedAtSelector,
  assignmentDetailsUpdatedAtByAdminSelector,
  payRateTypesSelector,
  isPayCodeTypesLoadingSelector,
  payCodesDetailsInfoSelector,
  workCodesSelector,
  isWorkCodesLoadingSelector,
  typesPayCodeSelector,
  isTypesPayCodeLoadingSelector,
  payCodesSelector,
};
